import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/odds-calculator',
  component: () => import('../../routes/OddsCalculator.svelte'),
  card: {
    id: 'odds-calculator',
    title: 'Sports Betting Odds Calculator',
    description: 'Convert between American, Decimal, and Fractional odds. Calculate parlay payouts, round robin combinations, and fair no-vig probabilities.',
    icon: 'sports',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/odds-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Sports Betting Odds Calculator – Convert Odds & Calculate Parlays',
    description: 'Free sports betting odds calculator. Convert between American, Decimal, and Fractional odds. Calculate parlay payouts, round robin bets, and fair no-vig probabilities.',
  },
};

export default meta;
